module.exports = __webpack_public_path__ + "img/lb15.858382e8.svg";